/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Error_GenericInputs */

const en_ui_intervals_error_generic = /** @type {(inputs: Ui_Intervals_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong talking to intervals.icu.`)
};

const de_ui_intervals_error_generic = /** @type {(inputs: Ui_Intervals_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Verbindung zu intervals.icu ist etwas schiefgelaufen.`)
};

/**
* | output |
* | --- |
* | "Something went wrong talking to intervals.icu." |
*
* @param {Ui_Intervals_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_error_generic = /** @type {((inputs?: Ui_Intervals_Error_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Error_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_error_generic(inputs)
	return de_ui_intervals_error_generic(inputs)
});